import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'reactstrap';
import BillingSummaryCard from './BillingSummaryCard';
import PaymentDetailsCard from './PaymentDetailsCard';
import PlanDetailsCard from './PlanDetailsCard';
import InvoicesTabs from './InvoicesTabs';
import InvoiceEditModal from './InvoiceEditModal';
import PaymentEditModal from './PaymentEditModal';
import ReplaceCardModal from './ReplaceCardModal';

import { getUserPlan, getUserCard } from '../../../../axios/subscription';
import { useAuthStore } from '../../../../zustand-store/auth.store';
import { PaymentForm, CreditCard } from 'react-square-web-payments-sdk';

export default function Billing() {
  const [billingData, setBillingData] = useState(null);
  const [isInvoiceModalOpen, setInvoiceModalOpen] = useState(false);
  const [isPaymentModalOpen, setPaymentModalOpen] = useState(false);
  const [replaceCardModal, setReplaceCardModal] = useState(false);
  const [loadingCard, setLoadingCard] = useState(false);

  const { id } = useAuthStore((state) => state);

  // Fetch plan and card
  const fetchBillingData = async () => {
    try {
      const planRes = await getUserPlan(id);
      if (planRes?.data) {
        const data = planRes.data;
        // Fetch latest card info if plan is not Starter
        if (data.currentPlan !== 'Starter') {
          setLoadingCard(true);
          try {
            const cardRes = await getUserCard(id);

            if (cardRes?.data) {
              const cardData = cardRes.data;
              data.card = {
                brand: cardData.brand || 'N/A',
                last4: cardData.last4 || '0000',
                expMonth: cardData.expMonth || 'MM',
                expYear: cardData.expYear || 'YYYY',
                id: cardData.id
              };
            }
          } catch (err) {
            console.error('Failed to fetch card:', err);
          } finally {
            setLoadingCard(false);
          }
        }

        setBillingData(data);
      }
    } catch (err) {
      console.error('Failed to fetch user plan:', err);
    }
  };

  useEffect(() => {
    fetchBillingData();
  }, [id]);

  if (!billingData) return <div className="text-center py-5">Loading...</div>;

  const { currentPlan, interval, subscriptionPayment, card, totalSeats, totalAmount } = billingData;

  const recentCharge = subscriptionPayment?.length > 0 ? subscriptionPayment[0].amount : 0;

  return (
    <div className="min-vh-100">
      <Container fluid>
        <h1 className="mb-5 text-dark">Billing</h1>
        <Row>
          <Col lg="6" className="mb-4">
            <BillingSummaryCard
              totalDue={totalAmount || 0}
              pastDue={0} // adjust if you have pastDue info
              recentCharges={recentCharge}
            />
          </Col>

          <Col lg="6" className="mb-4">
            <PlanDetailsCard
              plan={{
                name: currentPlan || 'Free Plan',
                billing: interval || 'Monthly',
                users: totalSeats || 1,
                price: recentCharge
              }}
              onChangePlan={() => console.log('Change Plan Modal Open')}
            />

            {currentPlan !== 'Starter' && (
              <>
                {loadingCard ? (
                  <div className="text-center py-3">Loading card info...</div>
                ) : card ? (
                  <PaymentDetailsCard
                    card={card}
                    onEdit={() => setPaymentModalOpen(true)}
                    onReplaceCard={() => setReplaceCardModal(true)}
                  />
                ) : (
                  <div className="text-center py-3">No card on file</div>
                )}
              </>
            )}
          </Col>
        </Row>

        <InvoicesTabs subscriptionPayment={subscriptionPayment} />

        <InvoiceEditModal
          isOpen={isInvoiceModalOpen}
          toggle={() => setInvoiceModalOpen(!isInvoiceModalOpen)}
          invoice={billingData}
        />
        <PaymentEditModal
          isOpen={isPaymentModalOpen}
          toggle={() => setPaymentModalOpen(!isPaymentModalOpen)}
          onReplaceCard={() => setReplaceCardModal(true)}
          card={card}
        />

        <ReplaceCardModal
          open={replaceCardModal}
          onClose={() => {
            setReplaceCardModal(false);
            fetchBillingData(); // Refresh plan & card after replacement
          }}
          PaymentForm={PaymentForm}
          CreditCard={CreditCard}
          prevCardId={card?.id}
        />
      </Container>
    </div>
  );
}
